import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, List, ListItem, ListItemIcon, Modal, Paper } from "@mui/material";
import { useState } from "react";
import { getIcon } from "utils/iconsConfig";
import { useLocation, useNavigate } from "react-router-dom";
import { useGlobalContext } from "context/GlobalContext";
import CreateServiceRequestModal from "../ServiceRequestFlowModals/CreateServiceModals/CreateServiceModal";
import BulkQuoteModal from "../BulkQuoteModal/BulkQuoteModal";
import { findSpecificMenu, findSpecificSubMenu, isAllowed } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";

const QuickDrawer = ({ open, handleClose, data }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permission = usePermissions();
  const pathName = location?.pathname;
  const [optionsClicked, setOptionsClicked] = useState("");
  const [hoveredItem, setHoveredItem] = useState("");
  const [hoveredItemSubcategory, setHoveredItemSubcategory] = useState("");
  const [openServiceModal, setOpenServiceModal] = useState(false);
  const [openBulkQuoteModal, setOpenBulkQuoteModal] = useState(false);
  const { setUpdateCatalogProductsData } = useGlobalContext();

  const handleButtonClick = (hoveredItem, subItem) => {
    if (subItem === "Bulk Quote") {
      setOpenBulkQuoteModal(true);
      setOptionsClicked("");
      handleClose();
      return;
    }

    const FirstOption = hoveredItem.split("Create ")[1];
    const SecondOption = subItem.split("By ")[1];

    let state = {
      innerChnages: true,
      backPath: FirstOption === "Set" ? `/${FirstOption}s` : FirstOption === "Order" ? `/${pathName.split("/")[1]}` : `/${pathName.split("/")[1]}`,
      newName: `${FirstOption === "Order" ? "Create" : "New"} ${FirstOption}`,
      collection: FirstOption === "Collection",
    };

    navigate(`/${SecondOption}`, { state });
    setOptionsClicked("");
    setUpdateCatalogProductsData([]);
    handleClose();
  };

  const handleMouseLeave = () => {
    setHoveredItem("");
    setOptionsClicked("");
  };

  const activeMainItem = hoveredItem || optionsClicked;
  const hasCreateOrderAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Quotes"), "create");
  const hasCreateCatalogAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Catalog Access"), "create");
  const hasCreateCollectionAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Collection Access"), "create");
  const hasCreateSetAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Sets Access"), "create");
  const ByCatalogAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Catalog Access"), "view");
  const ByCategoryAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Category Access"), "view");
  const ByCollectionAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Collection Access"), "view");
  const BySetsAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Sets Access"), "view");
  const ByStocksAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Stocks Access"), "view");

  const getDisplayLabel = (label) => {
    return label === "Create Order" ? "Create Quote" : label;
  };

  const getFilteredSubItems = (item) => {
    if (!item.subItems) return [];
    const subItemAccessMap = {
      "Create Order": {
        "By Category": ByCategoryAccess,
        "By Catalog": ByCatalogAccess,
        "By Collection": ByCollectionAccess,
        "By Sets": BySetsAccess,
        "By Stock": ByStocksAccess,
        "Bulk Quote": true,
      },
      "Create Catalog": {
        "By Category": ByCategoryAccess,
        "By Collection": ByCollectionAccess,
        "By Sets": BySetsAccess,
        "By Stock": ByStocksAccess,
      },
      "Create Collection": {
        "By Category": ByCategoryAccess,
      },
      "Create Set": {
        "By Category": ByCategoryAccess,
        "By Collection": ByCollectionAccess,
      },
    };

    const accessMap = subItemAccessMap[item.label];
    if (!accessMap) return [];

    // Filter sub-items based on view permissions
    return item.subItems.filter((subItem) => {
      const hasAccess = accessMap[subItem];
      return hasAccess === true;
    });
  };
  const filteredData = data?.filter((item) => {
    let hasCreateAccess = true;
    if (item.label === "Create Order") hasCreateAccess = hasCreateOrderAccess;
    if (item.label === "Create Catalog") hasCreateAccess = hasCreateCatalogAccess;
    if (item.label === "Create Collection") hasCreateAccess = hasCreateCollectionAccess;
    if (item.label === "Create Set") hasCreateAccess = hasCreateSetAccess;

    if (!hasCreateAccess) return false;
    if (item.label === "Create Service Request") return true;
    if (item.subItems) {
      const accessibleSubItems = getFilteredSubItems(item);
      return accessibleSubItems.length > 0;
    }

    return true;
  });
  const activeItem = filteredData?.find((item) => item.label === activeMainItem);
  const filteredActiveItem = activeItem
    ? {
        ...activeItem,
        subItems: getFilteredSubItems(activeItem),
      }
    : null;

  return (
    <>
      <Modal
        sx={{
          "& .MuiBackdrop-root": {
            backgroundColor: "transparent !important",
          },
        }}
        open={open}
        onClose={() => {
          setOptionsClicked("");
          handleClose();
        }}
        onMouseLeave={handleMouseLeave}
      >
        <Box
          sx={{
            position: "absolute",
            top: "80px",
            right: "230px",
            width: "200px",
            display: "flex",
            gap: "5px",
            bgcolor: "transparent",
            outline: "none",
            fontSize: "16px",
          }}
          onMouseLeave={() => setHoveredItem("")}
        >
          {/* Main Menu */}
          <Paper
            elevation={4}
            sx={{
              bgcolor: "white",
              borderRadius: 2,
              overflow: "hidden",
              minWidth: 210,
              height: "fit-content",
              maxHeight: "auto",
            }}
          >
            <List sx={{ p: 1 }}>
              {filteredData?.map((item) => (
                <ListItem key={item.label} disablePadding>
                  <div
                    onMouseEnter={() => {
                      setHoveredItem(item.label);
                      setOptionsClicked("");
                    }}
                    onClick={() => {
                      if (item.label === "Create Service Request") {
                        setOpenServiceModal(true);
                        return;
                      }
                      setOptionsClicked(item.label);
                    }}
                    style={{
                      padding: "8px 8px",
                      borderRadius: "6px",
                      whiteSpace: "nowrap",
                      backgroundColor: activeMainItem === item.label ? "#444444" : "white",
                      color: activeMainItem === item.label ? "white" : "black",
                      cursor: "pointer",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ flex: 1 }}>{getDisplayLabel(item?.label)}</div>
                    {item?.subItems?.length > 0 && getFilteredSubItems(item).length > 0 ? <ChevronRightIcon /> : ""}
                  </div>
                </ListItem>
              ))}
            </List>
          </Paper>

          {filteredActiveItem?.subItems?.length > 0 && (
            <Paper
              elevation={4}
              sx={{
                bgcolor: "white",
                borderRadius: 2,
                overflowY: "scroll",
                minWidth: 200,
                height: "fit-content",
                maxHeight: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              <List sx={{ p: 1 }}>
                {filteredActiveItem.subItems?.map((subItem) => (
                  <ListItem key={subItem} disablePadding>
                    <div
                      style={{
                        padding: "8px 8px",
                        borderRadius: "6px",
                        whiteSpace: "nowrap",
                        backgroundColor: hoveredItemSubcategory === subItem ? "#444444" : "white",
                        color: hoveredItemSubcategory === subItem ? "white" : "black",
                        cursor: "pointer",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                      }}
                      onMouseEnter={() => setHoveredItemSubcategory(subItem)}
                      onMouseLeave={() => setHoveredItemSubcategory("")}
                      onClick={() => handleButtonClick(activeMainItem, subItem)}
                    >
                      <ListItemIcon sx={{ minWidth: 32 }}>{getIcon(subItem, hoveredItemSubcategory === subItem ? "" : "black") || null}</ListItemIcon>
                      <div>{subItem}</div>
                    </div>
                  </ListItem>
                ))}
              </List>
            </Paper>
          )}
          <CreateServiceRequestModal
            open={openServiceModal}
            handleClose={() => {
              setOpenServiceModal(false);
              handleClose();
            }}
          />
        </Box>
      </Modal>

      {/* Bulk Quote Modal */}
        <BulkQuoteModal
          open={openBulkQuoteModal}
          onClose={() => {
            setOpenBulkQuoteModal(false);
            handleClose();
          }}
          headerText="Bulk Quote"
      />
    </>
  );
};

export default QuickDrawer;
